import moment from 'moment'

export const ACTION = {
  APPROVE: 'approved',
  REJECTED: 'rejected',
}

const getRandomInt = (max: number) => Math.floor(Math.random() * Math.floor(max))

export const getStartDate = () =>
  moment
    .utc()
    .clone()
    .subtract(getRandomInt(360), 'seconds')
    .format()
export const getEndDate = () =>
  moment
    .utc()
    .clone()
    .add(6, 'months')
    .format()
